import _ from 'lodash';

import { initializeApollo } from 'utils/apollo/client';
import DispensaryProductPage from 'src/dispensary/product';
import { getDispensary } from 'src/dispensary/hooks/use-dispensary';
import { getDispensaryProduct } from 'hooks/use-product';
import { EmbeddedDispensaryLayout } from 'src/components/layouts/embedded-dispensary-layout';

export const getStaticPaths = () => ({
  paths: [],
  // Fallback blocking is necessary here so that we get the correct 404
  // status code upon failure instead of the 200 from the fallback state
  fallback: `blocking`,
});

export const getStaticProps = async ({ params }) => {
  const apolloClient = initializeApollo();

  // 404 if no valid dispensary for cName param
  const { data } = await getDispensary(apolloClient, { params });
  const dispensary = _.get(data, `filteredDispensaries[0]`);
  if (!dispensary) {
    return {
      notFound: true,
      revalidate: 10,
    };
  }

  // 404 if no valid product for productId param
  const product = await getDispensaryProduct(apolloClient, params.productId, dispensary);
  if (!product) {
    return {
      notFound: true,
      revalidate: 10,
    };
  }

  // 200 if valid params
  return {
    props: {},
    revalidate: 10,
  };
};

DispensaryProductPage.layout = EmbeddedDispensaryLayout;
export default DispensaryProductPage;
